"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScenarioGroupDetailDTOToJSON = exports.ScenarioGroupDetailDTOFromJSONTyped = exports.ScenarioGroupDetailDTOFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function ScenarioGroupDetailDTOFromJSON(json) {
    return ScenarioGroupDetailDTOFromJSONTyped(json, false);
}
exports.ScenarioGroupDetailDTOFromJSON = ScenarioGroupDetailDTOFromJSON;
function ScenarioGroupDetailDTOFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return Object.assign(Object.assign({}, json), { 'createdBy': !runtime_1.exists(json, 'createdBy') ? undefined : _1.UserBaseDTOFromJSON(json['createdBy']), 'createdOn': !runtime_1.exists(json, 'createdOn') ? undefined : (runtime_1.parseDate(json['createdOn'])), 'modifiedBy': !runtime_1.exists(json, 'modifiedBy') ? undefined : _1.UserBaseDTOFromJSON(json['modifiedBy']), 'modifiedOn': !runtime_1.exists(json, 'modifiedOn') ? undefined : (runtime_1.parseDate(json['modifiedOn'])) });
}
exports.ScenarioGroupDetailDTOFromJSONTyped = ScenarioGroupDetailDTOFromJSONTyped;
function ScenarioGroupDetailDTOToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return Object.assign(Object.assign({}, value), { 'createdBy': _1.UserBaseDTOToJSON(value.createdBy), 'createdOn': value.createdOn === undefined ? undefined : (value.createdOn.toISOString()), 'modifiedBy': _1.UserBaseDTOToJSON(value.modifiedBy), 'modifiedOn': value.modifiedOn === undefined ? undefined : (value.modifiedOn.toISOString()) });
}
exports.ScenarioGroupDetailDTOToJSON = ScenarioGroupDetailDTOToJSON;
